export default "/rain.0db49995-29f640.svg";